"use client";

import type * as React from "react";
import { cn } from "@/lib/utils";

interface SegmentedProgressBarProps {
  /** 0–100 */
  value: number;
  /** number of segments (default 40) */
  segments?: number;
  className?: string;
}

/**
 * Segmented progress bar matching the site style (profile dashboard reward
 * bars). `flex-row-reverse` fills from the left in the RTL app.
 */
export const SegmentedProgressBar: React.FC<SegmentedProgressBarProps> = ({
  value,
  segments = 40,
  className,
}) => {
  const pct = Math.min(100, Math.max(0, value));
  const filled = Math.round((pct / 100) * segments);
  return (
    <div
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(pct)}
      className={cn(
        "flex flex-row-reverse items-center gap-px w-full",
        className,
      )}
    >
      {Array.from({ length: segments }, (_, i) => (
        <span
          // biome-ignore lint/suspicious/noArrayIndexKey: fixed-length static bar
          key={i}
          className={cn(
            "h-2 flex-1 rounded-[1px]",
            i < filled ? "bg-accent" : "bg-accent/20",
          )}
        />
      ))}
    </div>
  );
};
